import React, { Fragment, useEffect } from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";

import { Landing } from "views/pages/Landing";
import Tool from "views/pages/Tool";
import { Blog } from "views/pages/Blog";
import { BlogPost } from "views/pages/BlogPost";
import { Privacy } from "views/pages/Privacy";
import { Terms } from "views/pages/Terms";
import Submit from "views/pages/Submit";
import Dashboard from "views/pages/Dashboard";
import AdminDashboard from "views/pages/AdminDashboard";
import { SignIn } from "views/pages/SignIn";
import { NotFound } from "views/pages/NotFound";
import CategoryPage from "views/pages/CategoryPage";
import SubCategoryPage from "views/pages/SubCategoryPage";
import AlternativeToolsPage from "views/pages/AlternativeToolsPage";
import { SubmitSuccess } from "views/pages/SubmitSuccess";
import ToolSearch from "views/pages/ToolSearch";

const UserRoute = (props) => {
    return props.isLoggedIn ? <Route {...props} /> : <Redirect to="/sign-in" />;
};

const AdminRoute = (props) => {
    // Bypass admin check in development environment
    if (process.env.NODE_ENV === "development") {
        return <Route {...props} />;
    }
    return props.isAdmin ? <Route {...props} /> : <Redirect to="/dashboard" />;
};

const ScrollToTop = () => {
    const history = useHistory();

    useEffect(() => {
        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        });
        return () => {
            unlisten();
        };
    }, []);

    return null;
};

const AppRoutes = (props) => {
    const isAdmin = props.currentUser?.userAccount?.is_admin === true;

    return (
        <Fragment>
            <ScrollToTop />
            <Switch>
                {/* Landing */}
                <Route component={Landing} exact path="/" />
                <Route component={Dashboard} exact path="/dashboard" />
                <AdminRoute
                    component={AdminDashboard}
                    exact
                    path="/admin"
                    isAdmin={isAdmin}
                />
                <Route component={Tool} exact path="/tool/:name" />
                <Route
                    component={AlternativeToolsPage}
                    exact
                    path="/alternative/:toolName"
                />
                <Route component={Blog} exact path="/blog/:page?" />
                <Route component={BlogPost} exact path="/blog-post/:slug" />
                <Route component={Privacy} exact path="/privacy" />
                <Route component={Terms} exact path="/terms" />
                <Route component={Submit} exact path="/submit" />
                <Route component={SignIn} exact path="/sign-in" />
                <Route component={CategoryPage} exact path="/category" />
                <Route
                    component={SubCategoryPage}
                    exact
                    path="/category/:subcategory"
                />
                <Route component={SubmitSuccess} exact path="/submit-success" />
                <Route component={ToolSearch} exact path="/search" />

                {/* Sitemap */}
                <Route
                    path="/sitemap.xml"
                    render={() => {
                        window.location.href = "/sitemap.xml";
                        return null;
                    }}
                />

                {/* 404 */}
                <Route component={NotFound} exact path="/404" />
                <Redirect to="/404" />
            </Switch>
        </Fragment>
    );
};

export default AppRoutes;
